'use strict';

module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/Inflections.js
// module id = 72
// module chunks = 0